module.exports = __webpack_public_path__ + "static/media/semicolon-spammer-2.d178d117.gif";